import React, { useState } from "react";
import axios from "axios";
import { Button, Modal, TextInput } from "@opendate-app/setlist";

import { toastSuccess, toastError } from "../../../../shared/toastHelper";
import { useMarketingSettingsContext } from "../MarketingSettingsIndexContainer";

const footerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 12,
};

const SendTestOverlay = ({
  open,
  onClose,
  venueOwnership,
  sendDomain,
}) => {
  const {
    user,
    team,
    csrfToken,
  } = useMarketingSettingsContext();

  const [testInputValue, setTestInputValue] = useState(user.email);
  const [sending, setSending] = useState(false);

  const sendTest = (emails) => {
    setSending(true);
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.post(`/teams/${team.id}/venue_ownerships/${venueOwnership.id}/send_domains/${sendDomain.id}/test`, {
      emails: emails,
    })
      .then((response) => {
        toastSuccess(response.data.message);
      })
      .catch((error) => {
        toastError(error.response?.data?.errors?.join(", ") || error.message);
      })
      .finally(() => {
        setSending(false);
        onClose();
      });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Test email"
      footer={(
        <div style={footerStyle}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="primary"
            disabled={!testInputValue || sending}
            onClick={() => sendTest(testInputValue)}
          >
            {sending ? "Sending..." : "Send test"}
          </Button>
        </div>
      )}
    >
      <TextInput
        label="Send a test email to"
        type="text"
        placeholder="Example: b@xyz.com, a+test@xyz.com"
        hint="Separate addresses with commas."
        value={testInputValue}
        onChange={(e) => setTestInputValue(e.target.value)}
      />
    </Modal>
  );
};

export default SendTestOverlay;
